<!-- <p>footer works!</p> -->
<footer>
    <h1>This is the footer</h1>
  </footer>